import { render, staticRenderFns } from "./PricingModal.vue?vue&type=template&id=853f1dea"
import script from "./PricingModal.vue?vue&type=script&lang=js"
export * from "./PricingModal.vue?vue&type=script&lang=js"
import style0 from "./PricingModal.vue?vue&type=style&index=0&id=853f1dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports